import { forwardRef, lazy, Ref, Suspense } from 'react'
import { lazyLoadHelper } from 'routes/resources'
import LazyLoadingSkeleton from 'core/components/loaders/LazyLoadingSkeleton'
import {
  TripDetailProps,
  TripDetailRef
} from 'core/widgets/trip-detail/TripDetail'
import { useSettings } from 'core/hooks/settings/useSettings'

const TripDetail = lazy(() =>
  lazyLoadHelper(() => import('core/widgets/trip-detail/TripDetail'))
)

const PurpleTripDetail = lazy(() =>
  lazyLoadHelper(
    () => import('core/widgets/trip-detail/purple/PurpleTripDetail')
  )
)

const TripDetailLazy = forwardRef(
  (props: TripDetailProps, ref: Ref<TripDetailRef>) => {
    const {
      data: {
        featureFlags: { ENABLE_DRIVER_EXPERIENCE }
      }
    } = useSettings()

    return (
      <Suspense fallback={<LazyLoadingSkeleton variant="trip-detail" />}>
        {ENABLE_DRIVER_EXPERIENCE ? (
          <PurpleTripDetail ref={ref} {...props} />
        ) : (
          <TripDetail ref={ref} {...props} />
        )}
      </Suspense>
    )
  }
)

export default TripDetailLazy
